import LinkBase from './LinkBase.jsx';

export default function MenuItemBox({
  itemText,
  newTab = false,
  href,
  type,
  ariaLabel = null,
  externalCallback = () => {},
  iconName = '',
  iconPosition = 'after',
  isOpen,
  alwaysFocusable = false,
}) {
  function isTabbable() {
    if (alwaysFocusable) {
      return '0';
    }
    return isOpen ? '0' : '-1';
  }
  return (
    <div className={`lds-header-menu-item-${type}`}>
      {LinkBase({
        itemText,
        newTab,
        href,
        ariaLabel,
        iconName,
        iconPosition,
        externalCallback,
        tabIndex: isTabbable(),
      })}
    </div>
  );
}
